import { Box, SxProps, Theme } from '@mui/material';
import { Ban, Info, TriangleAlert } from 'lucide-react';
import { glyphLayoutSx } from './policy-glyph.styles';
import { getSeverityColors, PolicySeverity, SEVERITY_LABELS } from './policy-severity';

const GLYPHS = {
  restriction: Ban,
  warning: TriangleAlert,
  info: Info,
} as const;

const severityGlyphSx =
  (severity: PolicySeverity, extraOffsetY?: string): SxProps<Theme> =>
  (theme) => ({
    ...glyphLayoutSx(extraOffsetY),
    color: getSeverityColors(theme, severity).glyph,
  });

interface PolicySeverityGlyphProps {
  severity: PolicySeverity;
  size?: number;
  /** Decorative next to a labelled row; set when the glyph is the only cue. */
  titled?: boolean;
  /** Extra top offset, to follow a padded text block down. */
  extraOffsetY?: string;
}

export const PolicySeverityGlyph = ({
  severity,
  size = 13,
  titled,
  extraOffsetY,
}: PolicySeverityGlyphProps) => {
  const Glyph = GLYPHS[severity];

  return (
    <Box
      aria-hidden={titled ? undefined : true}
      role={titled ? 'img' : undefined}
      aria-label={titled ? SEVERITY_LABELS[severity] : undefined}
      sx={severityGlyphSx(severity, extraOffsetY)}
    >
      <Glyph size={size} />
    </Box>
  );
};
